import React from "react";
import { Form } from "react-bootstrap";
import Input from "../../../components/Input/Input";
import Button from "../../../components/Button/Button";
import Switch from "../../../components/Switch/Switch";
import "./MeetingWithType.css";

const MeetingWithTypeForm = ({
  submitHandler,
  changeHandler,
  name,
  programOptions,
  selectedProgramIds,
  onProgramToggle,
  onSelectAllPrograms,
}) => {
  return (
    <Form onSubmit={submitHandler}>
      <div className="row">
        <div className="col-md-12">
          <Input
            label="Name"
            type="text"
            name="name"
            value={name}
            placeholder="Enter meeting type name"
            onChangeHandler={changeHandler}
            required={true}
          />
        </div>

        <div className="col-md-12">
          <div className="meeting-programs-panel">
            <div className="meeting-programs-header">
              <Form.Label className="mb-0">Available for classes</Form.Label>
              <span className="meeting-programs-count">
                {selectedProgramIds.length}/{programOptions.length} selected
              </span>
            </div>

            <div className="mb-2">
              <Switch
                label="Select All Classes"
                value="1"
                checked={selectedProgramIds.length === programOptions.length && programOptions.length > 0}
                name="all"
                id="meeting-with-type-program-select-all"
                onChange={onSelectAllPrograms}
              />
            </div>

            <div className="meeting-programs-grid">
              <div className="row g-2">
                {programOptions.map((program) => (
                  <div className="col-md-6 col-lg-4" key={program.id}>
                    <div className="meeting-program-card">
                      <Switch
                        label={program.name}
                        id={`program-${program.id}`}
                        name="program_ids"
                        value={program.id}
                        checked={selectedProgramIds.includes(program.id.toString())}
                        onChange={onProgramToggle}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <Button variant="primary" type="submit">
          Submit
        </Button>
      </div>
    </Form>
  );
};

export default MeetingWithTypeForm;
